import { Stack, Text } from "@mantine/core";
import { ResponsiveBar } from "@nivo/bar";
import NumberUtils from "../../../utils/number.utils";
import './styles.scss';

interface Props {
  title: JSX.Element,
  data?: any[],
  keys: string[],
  indexBy?: string,
  marginBottom?: number,
  groupMode?: string,
  colors?: any,
  legendLabel?: any,
  legends?: any[],
  innerPadding?: number,
  axisLeftName: string,
  axisBottomName: string,
  axisBottomRotation?: number,

  formatValue?: (value: any) => string | number,
  formatXAxis?: (value: any) => string | number,
  tooltip?: (props: any) => any,
  toggler?: JSX.Element
}

function WidgetNivoBar(props: Props) {

  const {
    title,
    data,
    keys,
    indexBy,
    marginBottom,
    innerPadding,
    axisBottomName,
    axisLeftName,
    formatValue,
    tooltip,
    formatXAxis,
    axisBottomRotation,
    groupMode,
    colors,
    legendLabel,
    legends,
    toggler
  } = props;

  let curProps: any = {};

  if (formatValue) {
    curProps.label = formatValue;
    curProps.valueFormat = formatValue;
  }
  if (tooltip) {
    curProps.tooltip = tooltip;
  }

  function renderGraph() {
    if (data) {
      return (
        <ResponsiveBar
          data={data}
          keys={keys}
          indexBy={indexBy}
          margin={{ top: 5, right: 20, bottom: marginBottom, left: 45 }}
          padding={0.2}
          innerPadding={innerPadding ? innerPadding : 0}
          groupMode={groupMode ? groupMode : "stacked"}
          valueScale={{ type: 'linear' }}
          indexScale={{ type: 'band', round: true }}
          colors={colors ? colors : "#6CADD9"}
          borderRadius={0}
          enableLabel={false}
          legendLabel={legendLabel}
          legends={legends}
          borderColor={{
            from: 'color',
            modifiers: [
              [
                'darker',
                1.6
              ]
            ]
          }}
          layers={['grid', 'axes', 'bars', 'legends']}
          axisTop={null}
          axisRight={null}
          axisBottom={{
            format: formatXAxis,
            tickSize: indexBy ? 3 : 0,
            tickPadding: 3,
            tickRotation: axisBottomRotation || 0,
            legend: axisBottomName,
            legendPosition: 'middle',
            legendOffset: 40
          }}
          axisLeft={{
            format: v => NumberUtils.toShortened(v, 1),
            tickSize: 3,
            tickPadding: 3,
            tickRotation: 0,
            legend: axisLeftName,
            legendPosition: 'middle',
            legendOffset: -40
          }}
          role="application"
          tooltip={tooltip}
          ariaLabel="Nivo bar chart demo"
          barAriaLabel={function (e) {
            return e.id + ": " + e.formattedValue + " in country: " + e.indexValue
          }}
          {...curProps}
        />
      )
    } else {
      return (
        <Stack align="center">
          <Text>No Data Found</Text>
        </Stack>
      )
    }
  }

  return (
    <div className="widget-nivo-base">
      <div className="header">
        {title}
        {toggler}
      </div>
      <div className="widget-chart-container">
        {renderGraph()}
      </div>
    </div>
  )
}

export default WidgetNivoBar;
